<template>
  <div style="height: calc(100vh - 196px);">
    <vxe-toolbar
      id="toolbarId_ba9"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
        <el-button @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      show-footer
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="teamName"
          title="分组名称"
          min-width="60"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.teamName"
            placeholder="请输入分组名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipName"
          title="托运人名称"
          min-width="60"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipName"
            placeholder="请输入托运人名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipPhone"
          title="托运人手机号"
          min-width="60"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipPhone"
            placeholder="请输入托运人手机号"
            clearable
          />
        </template>
      </vxe-table-column>

      <!--      <vxe-table-column v-if="!parentData.isDetail" title="操作" fixed="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="退出车队" placement="top">
            <vxe-button type="text" @click="outTeam(scope.row.partyCode)">
              退出车队
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>-->
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "MyCarrierGroup",
  components: {},
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false
        };
      }
    }
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/driver/exportCarrierGroupList", //导出接口
        name: "我的承运分组"
      },
      message: "",
      loading: false,
      tableData: [],
      copy: false,
      listQuery: {
        driverCode: "",
        teamName: "",
        shipName: "",
        shipPhone: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
    };
  },
  created() {
    this.listQuery.driverCode = this.$route.query.partyCode;
    // this.findList()
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-basic-api/driver/carrierGroupList",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 退出车队
    outTeam(partyCode) {
      this.$confirm("确认退出吗？").then(_ => {
        request({
          url: "/ntocc-tms-api/acceptVehicle/exitTeam",
          method: "post",
          params: { teamCode: partyCode }
        }).then(response => {
          this.$message({ message: "退出成功", type: "success" });
          this.findList();
        });
      });
    }
  }
};
</script>

<style></style>
